/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Archetype_PrimaryInputs */

const en_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const de_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const fr_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const es_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const it_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const nl_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const pl_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const fi_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const da_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

const sv_deep_match_archetype_primary = /** @type {(inputs: Deep_Match_Archetype_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Deep_Match_Archetype_PrimaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_archetype_primary = /** @type {((inputs?: Deep_Match_Archetype_PrimaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Archetype_PrimaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_archetype_primary(inputs)
	if (locale === "fr") return fr_deep_match_archetype_primary(inputs)
	if (locale === "es") return es_deep_match_archetype_primary(inputs)
	if (locale === "it") return it_deep_match_archetype_primary(inputs)
	if (locale === "nl") return nl_deep_match_archetype_primary(inputs)
	if (locale === "pl") return pl_deep_match_archetype_primary(inputs)
	if (locale === "fi") return fi_deep_match_archetype_primary(inputs)
	if (locale === "da") return da_deep_match_archetype_primary(inputs)
	if (locale === "sv") return sv_deep_match_archetype_primary(inputs)
	return en_deep_match_archetype_primary(inputs)
});